import { Skeleton } from "../../../components/Skeleton";

const BADGE_PLACEHOLDER_COUNT = 4;

export function AchievementsWidgetBadgesSkeleton() {
    return (
        <div className="flex items-center justify-between gap-2">
            {Array.from({ length: BADGE_PLACEHOLDER_COUNT }, (_, index) => (
                <div
                    key={index}
                    className="py-2 px-4 flex flex-col gap-1 items-center max-w-[150px] flex-1"
                >
                    <Skeleton className="w-20 h-20 rounded-full shrink-0" />
                    <Skeleton className="h-3 w-24" />
                </div>
            ))}
        </div>
    );
}
